import styled from "styled-components";
import logo from "./img/cmt-logo.png";
import logoAP from "./img/ap-logo.png";
import logoMWW from "./img/waweb-logo.png";
import { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import {
  faMapPin,
  faAngleUp,
  faAngleDown,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import "./App.css";

const HomeContainer = styled.section`
  margin-top: ${(props) => (props.s1 ? "20vh" : "25vh")};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 1s;
`;

const HomeImgBox = styled.section`
  display: flex;
`;

const HomeSocialBox = styled.section`
  display: flex;
`;

const HomeTitle = styled.h2`
  font-size: 2.5em;
`;

const HomeText = styled.p`
  width: 50%;
  text-align: center;
`;

const HomeButton = styled.button`
  background: none;
  color: #ffffff;
  width: 36px;
  height: 36px;
  margin: 1rem 0px;
  padding: 0.5rem 0px;
  font-size: 1.2em;
  border: 1px #ffffff solid;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.7;
`;

const HomeSocialBtn = styled.button`
  background: none;
  color: #ffffff;
  width: 36px;
  height: 36px;
  font-size: 1.2em;
  border: 0px;
  cursor: pointer;
`;

const HomeImg = styled.img`
  width: ${(props) => (props.im ? "20vh" : "10vh")};
  display: inline;
  cursor: pointer;
`;

const BrandText = styled.a`
  cursor: pointer;
`;

class App extends Component {
  showSection(a, b) {
    document.getElementById("s" + a).classList.remove("is-no-active");
    document.getElementById("s" + b).classList.add("is-no-active");
  }

  redirect(link) {
    window.location = link;
  }

  render() {
    return (
      <>
        <HomeContainer id="s1" s1>
          <HomeImg
            alt="cmt-logo"
            src={logo}
            onClick={() => this.redirect("/")}
          />
          <HomeTitle>Website Development</HomeTitle>
          <HomeText>
            <FontAwesomeIcon icon={faMapPin} /> Cianjur, Jawa Barat, ID
          </HomeText>
          <HomeSocialBox>
            <HomeSocialBtn
              onClick={() =>
                this.redirect("https://instagram.com/cianjurmediatech_")
              }
            >
              <FontAwesomeIcon icon={faInstagram} />
            </HomeSocialBtn>
            <HomeSocialBtn
              onClick={() =>
                this.redirect(
                  "https://www.youtube.com/@onlinescriptindonesia2243"
                )
              }
            >
              <FontAwesomeIcon icon={faYoutube} />
            </HomeSocialBtn>
            <HomeSocialBtn
              onClick={() => this.redirect("mailto:corporation.np@gmail.com")}
            >
              <FontAwesomeIcon icon={faEnvelope} />
            </HomeSocialBtn>
          </HomeSocialBox>
          <HomeText>
            {new Date().getFullYear()} &copy; Copyrighted by {""}
            <BrandText onClick={() => this.redirect("/")}>
              Cianjur Media Tech.
            </BrandText>
          </HomeText>
          <HomeButton
            id="header"
            type="button"
            onClick={() => this.showSection("2", "1")}
          >
            <FontAwesomeIcon icon={faAngleDown} />
          </HomeButton>
        </HomeContainer>

        <HomeContainer id="s2" className="is-no-active">
          <HomeButton
            id="header"
            type="button"
            onClick={() => this.showSection("1", "2")}
          >
            <FontAwesomeIcon icon={faAngleUp} />
          </HomeButton>
          <HomeTitle>Cianjur Media Technology</HomeTitle>
          <HomeText>
            What we call Cianjur Media Tech. or with the abbreviation CMT, is a
            website development service in the Cianjur district, West Java.
          </HomeText>
          <HomeButton
            id="header"
            type="button"
            onClick={() => this.showSection("3", "2")}
          >
            <FontAwesomeIcon icon={faAngleDown} />
          </HomeButton>
        </HomeContainer>

        <HomeContainer id="s3" className="is-no-active">
          <HomeButton
            id="header"
            type="button"
            onClick={() => this.showSection("2", "3")}
          >
            <FontAwesomeIcon icon={faAngleUp} />
          </HomeButton>
          <HomeTitle>Our Service</HomeTitle>
          <HomeText>
            We provide services for <b>Website Development</b> with all needs,{" "}
            <b>Website Design</b> with the best design, and{" "}
            <b>Website Maintenance</b>.
          </HomeText>
          <HomeButton
            id="header"
            type="button"
            onClick={() => this.showSection("4", "3")}
          >
            <FontAwesomeIcon icon={faAngleDown} />
          </HomeButton>
        </HomeContainer>
        <HomeContainer id="s4" className="is-no-active">
          <HomeButton
            id="header"
            type="button"
            onClick={() => this.showSection("3", "4")}
          >
            <FontAwesomeIcon icon={faAngleUp} />
          </HomeButton>
          <HomeTitle>Another Thing We're Developing</HomeTitle>
          <HomeImgBox>
            <HomeImg
              im
              alt="aku-pramuka-logo"
              src={logoAP}
              onClick={() =>
                this.redirect(
                  "https://play.google.com/store/apps/details?id=com.nptech.akupramuka"
                )
              }
            />
            <HomeImg
              im
              alt="my-wa-web-logo"
              src={logoMWW}
              onClick={() =>
                this.redirect(
                  "https://play.google.com/store/apps/details?id=com.nptech.mywaweb"
                )
              }
            />
          </HomeImgBox>
        </HomeContainer>
      </>
    );
  }
}

export default App;
